import axios from "axios";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

export const productIsLoading = () => {
	return {
		type: "PRODUCT_IS_LOADING"
	};
};

export const productHasError = err => {
	return {
		type: "PRODUCT_HAS_ERROR",
		error: err
	};
};

export const productSuccess = payload => {
	return {
		type: "PRODUCT_SUCCESS",
		payload
	};
};

export const unloadProduct = () => {
	return {
		type: "PRODUCT_UNLOAD"
	};
};

export function getProduct(permalink, category = "") {
	// console.log("getting product in store");

	return (dispatch, getState) => {
		dispatch(productIsLoading());

		let token = "";
		let customerId = null;
		let topTierId = null;
		if (getState().user.customer){
			token = getState().user.customer.token;
			customerId = getState().user.customer.user.id
			topTierId = getState().user.customer.user.top_tier_id
		} 
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

		let args = "?category=" + category;
		if(customerId) args += "&customerId=" + customerId;
		if(topTierId) args += "&topTierId=" + topTierId;

		return axios
			.get(REACT_APP_API_URL + "products/" + permalink + args, { headers: AUTH_HEADER })
			.then(response => {
				// console.log("got product", response);
				dispatch(productSuccess(response));
			})
			.catch(err => {
				console.log("getProducts error:", err.response.statusText);
				dispatch(productHasError(err.response.statusText));
			});
	};
}

export const setProductFinalPrice = price => {
	return {
		type: "SET_PRODUCT_PRICE",
		price
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/product.js